import React from "react";
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer, Legend } from "recharts";
import "./ChartStyles.css";

const COLORS = ["violet", "purple"]; // Green for Correct, Red for Wrong

const PieChartCate = ({ cdata }) => {
  // Aggregate total correct and wrong answers across all categories
  const totalCorrect = cdata.reduce((sum, item) => sum + item.TotalCorrectAnswers, 0);
  const totalWrong = cdata.reduce((sum, item) => sum + item.TotalWrongAnswers, 0);

  const pieData = [
    { name: "Correct", value: totalCorrect },
    { name: "Wrong", value: totalWrong }
  ];

  return (
    <div>
        <h2 className="chart-title">Overall Quiz Performance</h2>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={pieData}
              cx="50%"
              cy="50%"
              outerRadius={120}
              label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(1)}%`}
              fill="#8884d8"
              dataKey="value"
            >
              {pieData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index]} />
              ))}
            </Pie>
            <Tooltip formatter={(value, name) => [`${value}`, `${name}`]} />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
  );
};

export default PieChartCate;
